import { X } from "@phosphor-icons/react";
import clsx from "clsx";

import usePageTitle from "common/hooks/usePageTitle";

import Layout from "./Layout";

import type { ReactNode } from "react";

function ContentContainer({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "flex grow flex-col max-h-full lg:bg-white/90 lg:border lg:border-black-100 lg:rounded-3xl lg:shadow-xl overflow-hidden",
        className,
      )}
    >
      {children}
    </div>
  );
}
function ContentHeader({ children }: { children: ReactNode }) {
  return (
    <div className="flex justify-between flex-wrap lg:border-b lg:border-b-black-200 shrink-0 max-lg:min-h-16 lg:h-[60px] max-lg:pt-6 px-4 items-center gap-4">
      {children}
    </div>
  );
}
function ContentScroll({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}) {
  return (
    <div
      id="content-scroll"
      className={clsx(
        "flex overflow-y-auto overflow-x-hidden flex-col scrollbar-thin grow",
        className,
      )}
    >
      {children}
    </div>
  );
}
function PageTitle({ children }: { children?: string }) {
  const pageTitle = usePageTitle();

  return (
    <h1 className="text-md-bold lg:text-lg-bold">{children || pageTitle}</h1>
  );
}

function Sidebar({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  if (isOpen) {
    return (
      <ContentContainer className="max-w-[352px] shrink-0 flex-col relative w-full overflow-y-auto scrollbar-thin">
        <button
          type="button"
          className="absolute right-3 top-2.5"
          onClick={onClose}
          aria-label="close"
        >
          <X size={16} />
        </button>
        {children}
      </ContentContainer>
    );
  }
}

export default Layout;
export { PageTitle, ContentContainer, ContentHeader, ContentScroll, Sidebar };
